import React, { useCallback } from "react";

import PageHeading from "2g-page-heading";

import { STAV } from "b2b/constants/zadosti";
import getNextWeekDates from "b2b/utils/date/getNextWeekDates";
import ZadostiGroups from "b2b/components/zadosti-groups";

export function ZadostiGroupsExample() {
  const onClick = useCallback((data = "all") => {
    console.log("on click item : ", data); // eslint-disable-line no-console
  }, []);
  const obdobi = { ...getNextWeekDates() };
  return (
    <>
      <div data-testid="test-zadostiGroups-danger">
        <PageHeading>ZadostiGroups - danger</PageHeading>
        <ZadostiGroups
          datumDo={obdobi.datumDo}
          datumOd={obdobi.datumOd}
          onChange={onClick}
          stav={STAV.PRIJATY}
        />
      </div>
      <div data-testid="test-zadostiGroups-success">
        <PageHeading>ZadostiGroupsContent - success</PageHeading>
        <ZadostiGroups
          datumDo={obdobi.datumDo}
          datumOd={obdobi.datumOd}
          onChange={onClick}
          showAll={true}
          stav={STAV.POTVRZENY}
        />
      </div>
    </>
  );
}

export default React.memo(ZadostiGroupsExample);
